interface BuildAgentUrlParams {
  baseUrl: string;
  aiPort?: string | null;
  path: string;
  src?: string | null;
}

export const buildAgentUrl = ({
  baseUrl,
  aiPort,
  path,
  src,
}: BuildAgentUrlParams): string => {
  const url = `${baseUrl}${aiPort ? `:${aiPort}` : ''}${path}`;

  if (!src) return url;

  const queryParams = new URLSearchParams({ src });

  return `${url}?${queryParams.toString()}`;
};
